import {
    useCallback,
} from 'react'
import {
    useNavigate,
} from 'react-router-dom'
import EngagementForm from 'app/Apps/RelationshipsManagement/Engagement/EngagementForm'
import requests from 'app/requests/Engagement.requests'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

const EngagementsDemoCreateForm = () => {
    const navigate = useNavigate()

    const onSuccess = useCallback((data: { id: number, isProspect: boolean }) => {
        /* calculate custom redirect routes to ensure proper navigation based on data
         , useRelationshipManagementRoutes won’t work here properly so using templates */
        if (data.isProspect) {
            navigate(`../${CommonRoutes.All}/${CommonRoutes.Edit}/${data.id}`)
        } else {
            navigate(`../contacts/${CommonRoutes.Edit}/${data.id}`)
        }
    }, [navigate])

    return (
        <EngagementForm
            onSuccess={onSuccess}
            requestParam={requests.create()}
        />
    )
}

export default EngagementsDemoCreateForm
